// import { OverviewIcon, ProjectManagerIcon, UserClientIcon, UserSettingIcon, UserTeamIcon } from 'assets';
// import { routeConstant } from 'shared/routes/RouteConstant';

const dropdownLogOutOptions = [
    {
        title: 'Edit Profile'
    },
    {
        title: 'Logout'
    }
];
export { dropdownLogOutOptions };
